export default __webpack_public_path__ + "7f3ee1de3bfcf2261bdb2e606376e53b.svg";